import { isBrowser } from "./util"

// Human-readable "where did this submission come from" label. sendContact()
// posts it as opt_in_source; the receiving lambdas (contactUs, sampleRequest,
// techSpecialist, the two sampling processors) log its path and stamp it on
// the notification emails. It is deliberately NOT sent by signUp() or
// setEmailPreferences(): those lambdas write OptInSource to the master
// subscriber DE, a marketing-owned column of unknown length, and the ticket
// only asks for the source in the logs. subscribe already gets form_identifier
// and both lambdas can log the Referer path server-side.
//
// It is derived at submit time from the rendered page rather than passed by
// each template because:
//   - document.title is set by the SEO component from the DatoCMS page title
//     (or seo.title), so it already IS the "form title" marketing asked for;
//   - the pathname is the part that answers "e.g. .com/contact-us";
//   - the services are identical on master and staging while the templates
//     are not, so a change here cherry-picks cleanly.
//
// Example: "Contact Us (/contact-us/)". The " | WD-40" titleTemplate suffix is
// dropped - it says nothing about the form. Capped at 200 chars.
const TITLE_SUFFIX = / \| WD-40$/
const MAX_LENGTH = 200

export const getFormSource = (explicit) => {
    if (explicit) return String(explicit).slice(0, MAX_LENGTH)
    if (!isBrowser()) return ''
    const title = (document.title || '').replace(TITLE_SUFFIX, '').trim()
    const path = window.location.pathname || ''
    const label = title ? `${title} (${path})` : path
    return label.slice(0, MAX_LENGTH)
}
